import * as Yup from 'yup';


const EquifaxFeesValidationSchema =  Yup.object().shape({
    name : Yup.string().required('Required'),
    txnCode : Yup.string().required('Required'),
    amount : Yup.string().required('Required') .matches(/^\d+(\.\d{1,2})?$/, "Must be a valid number with up to two decimal places"),
});
 
export { EquifaxFeesValidationSchema } ;